import * as React from 'react';
import { SVGProps } from 'react';

export const Headboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.42623 4.75H26.5738C28.6041 4.75 30.25 6.3959 30.25 8.42623V22.1967C30.25 22.869 29.705 23.4139 29.0328 23.4139H2.96721C2.29496 23.4139 1.75 22.869 1.75 22.1967V8.42623C1.75 6.3959 3.3959 4.75 5.42623 4.75Z"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M4.93457 26.1313L4.93457 24.1641"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M27.5576 26.1313L27.5576 24.1641"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export default Headboard;
